webpackJsonp([1],{

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(49)("14523850", content, true, {});

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(38)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderPlataforma_vue__ = __webpack_require__(939);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0ae828c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderPlataforma_vue__ = __webpack_require__(1061);
function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var normalizeComponent = __webpack_require__(347)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderPlataforma_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0ae828c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderPlataforma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(49)("40d52a5c", content, true, {});

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(38)(false);
// imports


// module
exports.push([module.i, ".desplegable-perfil .dropdown-toggle:after{display:inline-block;margin-left:0;vertical-align:.255em;content:\"\";border-top:.6em solid #0078cf;border-right:.6em solid transparent;border-bottom:0;border-left:.6em solid transparent}.desplegable-perfil button{background:#ff000000!important;color:#212121!important;border:none!important}.desplegable-perfil button:focus{outline:none!important;box-shadow:none!important}.desplegable-perfil ul.dropdown-menu{right:0!important}.desplegable-perfil .dropdown-item.active,.desplegable-perfil .dropdown-item:active{color:#212121;background-color:#e7e7e7}.desplegable-perfil .dropdown-item{padding:1rem 1.5rem}", ""]);

// exports


/***/ }),

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"container-fluid header",class:{ 'd-none': _vm.userapp }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 col-sm-3 col-md-2 text-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(638),"width":"100px"}})])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-none d-sm-block col-sm-2 col-md-6 text-right align-middle vcenter content-btn"},[(!_vm.$root.$userLogged)?_c('div',[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":"/login"}},[_vm._v("Ingresa a tu cuenta")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/registroUsuarioOption"}},[_vm._v("Regístrate")])],1):_c('div',[_c('b-dropdown',{staticClass:"desplegable-perfil",scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('span',{staticClass:"welcome"},[_c('img',{attrs:{"src":__webpack_require__(653),"alt":""}}),_vm._v("\n                        ¡Hola "+_vm._s(_vm._f("upper")(_vm.$root.$nameUser))+"!\n                      ")])]},proxy:true}])},[_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":"/EditarUsuario"}},[_vm._v("Mi perfil")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.logoutInterno()}}},[_vm._v("Cerrar sesión")])],1)],1)])])]),_vm._v(" "),(_vm.load)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.$root.$userLogged || _vm.validaPaginaActual())?_c('nav',{staticClass:"general",attrs:{"aria-label":"breadcrumb"}},[_c('div',{staticClass:"container"},[_c('ol',{staticClass:"breadcrumb",class:{ 'd-none': _vm.userapp }},_vm._l((_vm.title),function(item,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n                  "+_vm._s(item.name)+"\n                  ")])],1)}),0)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col h1-vecenter"},[_c('h1',[_vm._v("Plataforma Digital de Atención al Ciudadano")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('headerPlataforma'),_vm._v(" "),_c('div',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlataformaLayout_vue__ = __webpack_require__(938);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d42bda12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlataformaLayout_vue__ = __webpack_require__(1062);
function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var normalizeComponent = __webpack_require__(347)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlataformaLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d42bda12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlataformaLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "loader.png?906bd902525a623d3491350af83d1e48";

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-miraflores.png?cff0a8c460e3722444026239b9e6687d";

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "user.png?e97a19018afa3007312be416b9376a4c";

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 879:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__ = __webpack_require__(849);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54dcbd36_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__(882);
function injectStyle (ssrContext) {
  __webpack_require__(880)
}
var normalizeComponent = __webpack_require__(347)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54dcbd36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54dcbd36_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(881);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(49)("1c01939f", content, true, {});

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(38)(false);
// imports


// module
exports.push([module.i, ".relative[data-v-54dcbd36]{position:absolute;width:100%;min-height:calc(100vh - 75px)}.content_loader[data-v-54dcbd36]{position:absolute;z-index:999;top:0;background:#eaf0f9;width:100%;height:100%}.loader-content img[data-v-54dcbd36]{position:relative;z-index:1;max-width:65px}.loader-content[data-v-54dcbd36]{position:relative;display:flex;padding:51px;margin:auto;height:100%;width:100%;align-items:center;justify-content:center}.loader-circle[data-v-54dcbd36]{width:102px;height:102px;border-radius:50%;box-shadow:inset 0 0 0 1px hsla(0,0%,100%,.1);background:#fff}.loader-circle[data-v-54dcbd36],.loader-line-mask[data-v-54dcbd36]{position:absolute;left:50%;top:50%;margin-left:-51px;margin-top:-51px}.loader-line-mask[data-v-54dcbd36]{width:60px;height:120px;overflow:hidden;-webkit-transform-origin:51px 51px;-moz-transform-origin:51px 51px;-ms-transform-origin:51px 51px;-o-transform-origin:51px 51px;transform-origin:51px 51px;-webkit-animation:rotate-data-v-54dcbd36 1.2s infinite linear;-moz-animation:rotate-data-v-54dcbd36 1.2s infinite linear;-o-animation:rotate-data-v-54dcbd36 1.2s infinite linear;animation:rotate-data-v-54dcbd36 1.2s infinite linear}.loader-line-mask .loader-line[data-v-54dcbd36]{width:102px;height:102px;border-radius:50%;box-shadow:inset 0 0 0 3px #0078cf}@-webkit-keyframes rotate-data-v-54dcbd36{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@-moz-keyframes rotate-data-v-54dcbd36{0%{-moz-transform:rotate(0deg)}to{-moz-transform:rotate(1turn)}}@-o-keyframes rotate-data-v-54dcbd36{0%{-o-transform:rotate(0deg)}to{-o-transform:rotate(1turn)}}@keyframes rotate-data-v-54dcbd36{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn);-ms-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes fade-data-v-54dcbd36{0%{opacity:1}50%{opacity:.25}}@-moz-keyframes fade-data-v-54dcbd36{0%{opacity:1}50%{opacity:.25}}@-o-keyframes fade-data-v-54dcbd36{0%{opacity:1}50%{opacity:.25}}@keyframes fade-data-v-54dcbd36{0%{opacity:1}50%{opacity:.25}}lesshat-selector[data-v-54dcbd36]{-lh-property:0}@-webkit-keyframes fade-in-data-v-54dcbd36{0%{opacity:0}to{opacity:1}}@-moz-keyframes fade-in-data-v-54dcbd36{0%{opacity:0}to{opacity:1}}@-o-keyframes fade-in-data-v-54dcbd36{0%{opacity:0}to{opacity:1}}@keyframes fade-in-data-v-54dcbd36{0%{opacity:0}to{opacity:1}}[not-existing][data-v-54dcbd36]{zoom:1}", ""]);

// exports


/***/ }),

/***/ 882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"content_loader"},[_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"loader-circle"}),_vm._v(" "),_c('div',{staticClass:"loader-line-mask"},[_c('div',{staticClass:"loader-line"})]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(637)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 938:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_HeaderPlataforma__ = __webpack_require__(1058);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    headerPlataforma: __WEBPACK_IMPORTED_MODULE_0__components_Header_HeaderPlataforma__["a" /* default */]
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_commons_loader__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__ = __webpack_require__(95);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_0__components_commons_loader__["a" /* default */]
  },

  created: function created() {
    var _this = this;

    // console.log("VALOR==================>00000000000000000")
    __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__["a" /* default */].$on('userapp1', function (val) {
      _this.userapp = val;
    });

    __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__["a" /* default */].$on('loadershow', function (val) {
      _this.showloader(val);
    });
  },
  destroyed: function destroyed() {
    // console.log("USERAPP1USERAPP1USERAPP1USERAPP1")
    __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__["a" /* default */].$emit("userapp1", true);
  },
  data: function data() {
    return {
      userapp: false,
      imagen: './assets/logo_miraflores_fblanco.png',
      login: 0,
      load: null,
      title: [{
        link: "",
        name: "Plataforma"
      }],
      paginaActual: null,
      paginasPermitidas: ['pageMultasAdministrativas', 'pageMultasAdministrativasEstadoCuenta', 'solicitudInfPublica']
    };
  },
  mounted: function mounted() {
    // console.log("VALOR==================>00000000000000000")
    if (localStorage.getItem("userapp1") == true) {
      this.userapp = true;
    }
  },

  methods: {
    showloader: function showloader(val) {
      this.load = val;
    },
    logoutInterno: function logoutInterno() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_EventBus_js__["a" /* default */].$emit('logout');
      this.$router.push('/login');
    },
    validaPaginaActual: function validaPaginaActual() {
      var valida = false;

      if (this.paginasPermitidas.includes(this.paginaActual)) {
        valida = true;
      }

      return valida;
    }
  },
  filters: {
    upper: function upper(value) {
      if (value) {
        return value.toLowerCase();
      } else {
        return "";
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // console.log("TOOOOtHEADER",to)
      this.title = to.meta.breadCrumb;
      //console.log(to.name)
      this.paginaActual = to.name;
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// 1.af1a5ef800fe46f72e30.bundle.js?v0.8910010824215415